<template>
  <div class="languages-selector">
    <h4 :class="{ 'text-danger': invalidFeedback }"><b>{{name}}{{required ? '*' : ''}}</b></h4>
    <p :class="{ 'text-danger': invalidFeedback, 'text-muted': !invalidFeedback }">{{description}}</p>
    <b-form-group
      label="Languages"
      label-for="user"
    >
      <multiselect
        :value="options.filter(el => Array.isArray(value) && value.includes(el.key))"
        @input="$emit('input', $event.map(({ key }) => key))"
        :close-on-select="false"
        :clear-on-select="false"
        :preserve-search="true"
        :options="options && options.length ? options : []"
        :multiple="true"
        label="name"
        track-by="key"
        placeholder="Select languages"
        class="multiselect-rlnx"
      >
        <template v-slot:noResult>Language not found, try something similar</template>
      </multiselect>
      <div v-if="invalidFeedback" class="text-danger">{{invalidFeedback}}</div>
    </b-form-group>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import ISO6391 from 'iso-639-1';

export default {
  name: 'JobTitleSelector',
  components: {
    Multiselect
  },
  props: {
    name: {
      type: String,
    },
    description: {
      type: String,
    },
    value: {
      default: () => [],
    },
    invalidFeedback: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => ISO6391.getAllCodes().map(key => ({ key, name: ISO6391.getName(key) })),
    },
  },
};
</script>

<style lang="scss">
.languages-selector {
  .multiselect-rlnx {
    .multiselect__tags {
      height: auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/profile/LanguagesSelector.vue